export default {
	FETCH_COMPANY: (state, fetched) => {
		let storeCompany = state.companies.find(el => el.id === fetched.data.id)
		let fetchedCompany = fetched.data

		if (storeCompany !== undefined) {
			let storeCompanyFields = Object.getOwnPropertyNames(storeCompany)
			let fetchedCompanyFields = Object.getOwnPropertyNames(fetchedCompany)

			let fieldsToUpdate = fetchedCompanyFields.filter(x => storeCompanyFields.includes(x))
			fieldsToUpdate = fieldsToUpdate.filter(field => field !== 'distance')
			let detailFields = fetchedCompanyFields.filter(x => !storeCompanyFields.includes(x))
			
			// update saved company with fetched company -> only the fields both share
			fieldsToUpdate.forEach(key => {
				storeCompany[key] = fetchedCompany[key]
			})

			// add company details to save the new company object in the store
			let companyDetails = {}
			detailFields.forEach(key => {
				companyDetails[key] = fetchedCompany[key]
			})
			storeCompany.details = companyDetails

			// update saved company with new company object
			let index = state.companies.indexOf(storeCompany)
			state.companies[index] = storeCompany
			//console.log(`Updated company with id: ${storeCompany.id}. Added Details. Index was: ${index}.`)
			state.companies.push({ id: '-1' })
			state.companies.pop()
		} else {
			// company doesn't exist in store --> add it
			let saveCompany = {}

			let primaryFields = [
				'category',
				'coords',
				'language',
				'season',
				'criteria',
				'id',
				'image_url',
				'isTopPerformance',
				'likes',
				'title',
				'translations',
				'distance',
				'designation',
				'webcam_typ',
				'webcam_link'
			]

			// fill saveCompany obj with fetched data
			primaryFields.forEach(key => {
				Object.assign(saveCompany, { [key]: fetched.data[key]})
			})

			// init company details
			let companyDetails = { details: {} }
			Object.assign(saveCompany, companyDetails)
			let detailFields = Object.getOwnPropertyNames(fetched.data).filter(field => !primaryFields.includes(field))


			// fill saveCompany obj details with fetched data details
			detailFields.forEach(key => {
				Object.assign(saveCompany.details, { [key]: fetched.data[key] } )
			})
			state.companies.push(saveCompany)
			//console.log(`Fetched new company with details. ID was: ${saveCompany.id}`)
		}
	},
	FETCH_COMPANIES: (state, fetched) => {
		if(fetched !== undefined && fetched.data !== undefined) {
			fetched.data.forEach(company => {
				// add company metas (language and season)
				Object.assign(company, fetched.meta)

				// init company details
				let companyDetails = { details: {} }
				Object.assign(company, companyDetails)

				let existingCompany = state.companies.find(el => {
					return el.id === company.id
				})

				if (existingCompany !== undefined) {
					// company exists in store -> update with probably new Data
					if (existingCompany.details !== undefined) {
						companyDetails.details = existingCompany.details
					}

					let index = state.companies.indexOf(existingCompany)
					Object.assign(company, companyDetails)
					state.companies[index] = company
					//console.log(`Updated company with id: ${company.id} in store. Index was: ${index}.`)
					state.companies.push({ id: '-1' })
					state.companies.pop()
				} else {
					// write company to store
					//console.log(`Added company ${company.id} to store. Designation was ${company.designation}`)
					state.companies.push(company)
				}
			})
		}
	},
	FETCH_CATEGORIES: (state, fetched) => {
		if(fetched !== undefined && fetched.data !== undefined) {
			fetched.data.forEach(cat => {
				let existingCat = state.categories.find(el => {
					return el.id === cat.id
				})

				if (existingCat !== undefined) {
					let index = state.categories.indexOf(existingCat)
					state.categories[index] = cat
					//console.log(`Updated category with id: ${cat.id} in store. Index was: ${index}.`)
					state.categories.push({ id: '-1' })
					state.categories.pop()
				} else {
					// write categories to store
					state.categories.push(cat)
				}
			})
		}
	},
	FETCH_CRITERIAS: (state, fetched) => {
		if(fetched !== undefined && fetched.data !== undefined) {
			fetched.data.forEach(criteria => {
				let existingCriteria = state.criterias.find(el => {
					return el.id === criteria.id
				})

				if (existingCriteria !== undefined) {
					let index = state.criterias.indexOf(existingCriteria)
					state.criterias[index] = criteria

					state.criterias.push({ id: '-1' })
					state.criterias.pop()

					//console.log(`Updated category with id: ${criteria.id} in store. Index was: ${index}.`)
				} else {
					// write criterias to store
					state.criterias.push(criteria)
				}
			})
		}
	},
	FETCH_BONUS_CATEGORIES: (state, fetched) => {
		if(fetched !== undefined && fetched.data !== undefined) {
			fetched.data.forEach(bonusCat => {
				let existingBonusCat = state.bonusCategories.find(el => {
					return el.id === bonusCat.id
				})

				if (existingBonusCat !== undefined) {
					let index = state.criterias.indexOf(existingBonusCat)
					state.bonusCategories[index] = bonusCat

					state.bonusCategories.push({ id: '-1' })
					state.bonusCategories.pop()
					//console.log(`Updated category with id: ${bonusCat.id} in store. Index was: ${index}.`)
				} else {
					// write bonus category to store
					state.bonusCategories.push(bonusCat)
				}
			})
		}
	},
	FETCH_SALESPOINTS: (state, fetched) => {
		if (fetched !== undefined && fetched.data !== undefined) {
			fetched.data.forEach(sale => {
				// add salespoint metas (language and season)
				Object.assign(sale, fetched.meta)

				let existingSalespoint = state.salespoints.find(el => {
					return el.id === sale.id
				})

				if (existingSalespoint !== undefined) {
					// sales point exists in store -> update with probably new Data

					let index = state.salespoints.indexOf(existingSalespoint)
					state.salespoints[index] = sale
					//console.log(`Updated salespoint with id: ${sale.id} in store. Index was: ${index}.`)
					// trigger store update since we override existing store values
					state.salespoints.push({ id: '-1' })
					state.salespoints.pop()
				} else {
					// write sales points to store
					state.salespoints.push(sale)
				}
			})
		}
	},
	FETCH_SALESPOINT: (state, fetched) => {
		let storeSalespoint = state.salespoints.find(el => el.id === fetched.data.id)
		let fetchedSalespoint = fetched.data

		if (storeSalespoint !== undefined) {
			let storeSalespointFields = Object.getOwnPropertyNames(storeSalespoint)
			let fetchedSalespointFields = Object.getOwnPropertyNames(fetchedSalespoint)

			let fieldsToUpdate = fetchedSalespointFields.filter(x => storeSalespointFields.includes(x))
			fieldsToUpdate = fieldsToUpdate.filter(field => field !== 'distance')
			let detailFields = fetchedSalespointFields.filter(x => !storeSalespointFields.includes(x))
			
			// update saved sales point with fetched sales point -> only the fields both share
			fieldsToUpdate.forEach(key => {
				storeSalespoint[key] = fetchedSalespoint[key]
			})

			// add sales point details to save the new sales point object in the store
			let salespointDetails = {}
			detailFields.forEach(key => {
				salespointDetails[key] = fetchedSalespoint[key]
			})
			storeSalespoint.details = salespointDetails

			// update saved sales point with new sales point object
			let index = state.salespoints.indexOf(storeSalespoint)
			state.salespoints[index] = storeSalespoint

			state.salespoints.push({ id: '-1' })
			state.salespoints.pop()

			//console.log(`Updated salespoint with id: ${storeSalespoint.id}. Added Details. Index was: ${index}.`)
		} else {
			state.salespoints.push(fetched.data)
			//console.log(`Fetched new salespoint with details. ID was: ${fetched.data.id}`)
		}
	},
	FETCH_CARDINFOS: (state, fetched) => {
		if(fetched !== undefined && fetched.data !== undefined) {
			fetched.data.forEach(cardInfo => {
				// add company metas (language and season)
				Object.assign(cardInfo, fetched.meta)

				let existingCardInfo = state.cardinfos.find(el => {
					return el.id === cardInfo.id
				})

				if (existingCardInfo !== undefined) {
					let index = state.cardinfos.indexOf(existingCardInfo)
					state.cardinfos[index] = cardInfo
					state.cardinfos.push({ id: '-1' })
					state.cardinfos.pop()
					//console.log(`Updated card info with id: ${cardInfo.id} in store. Index was: ${index}.`)
				} else {
					// write card infos to store
					state.cardinfos.push(cardInfo)
				}
			})
		}
	},
	FETCH_NEWS: (state, fetched) => {
		if (fetched !== undefined && fetched.data !== undefined) {
			fetched.data.forEach(newsPost => {
				let existingNewsPost = state.news.find(el => {
					return el.id === newsPost.id
				})

				if (existingNewsPost !== undefined) {
					let index = state.news.indexOf(existingNewsPost)
					state.news[index] = newsPost
					state.news.push({ id: '-1' })
					state.news.pop()
					//console.log(`Updated news post with id: ${newsPost.id} in store. Index was: ${index}.`)
				} else {
					// write news post to store
					state.news.push(newsPost)
				}
			});
		}
	},
	UPDATE_LANGUAGE: (state, newLang) => {
		state.language = newLang
	},
	UPDATE_SEASON: (state, newSeason) => {
		state.season = newSeason
	},
	ADD_TO_LIKED_COMPANIES: (state, translations) => {
		if (translations !== undefined) {
			let languages = [
				'de',
				'en',
				'it',
				'sl'
			]

			languages.forEach(key => {
				if (translations[key] !== undefined) {
					let companyExists = state.likedCompanies.includes(translations[key])
					if (!companyExists) {
						state.likedCompanies.push(translations[key])
					}
				}
			})
		}
	},
	UPDATE_CURRENT_POSITION: (state, newPosition) => {
		state.currentPosition = newPosition
	},
	UPDATE_SELECTED_SERVICE: (state, newService) => {
		state.selectedService = newService
	},
	CREATE_BOOKMARK: (state, obj) => {
		let alreadyAdded = state.bookmarks.includes(obj.id)
		if (!alreadyAdded) {
			state.bookmarks.push(obj)
			//console.log(`Added ${obj.type} - ${obj.id} to bookmarks.`)
		} else {
			//console.log(`Can't add ${obj.type} - ${obj.id} to bookmarks. Already marked.`)
		}
	},
	REMOVE_BOOKMARK: (state, id) => {
		state.bookmarks = state.bookmarks.filter(mark => mark.id !== id)
	},
	REGISTER_CARD: (state, cardObj) => {
		if (cardObj) {
			let alreadyAdded = state.cards.includes(cardObj.cardID)
			if (!alreadyAdded) {
				state.cards.push(cardObj)
			} else {
				//console.log(`Can't add ${cardObj.id} to cards. Already exists`)
			}
		} else {
			//console.log(`No Card Object supplied.`)
		}
	},
	UPDATE_CARD: (state, obj) => {
		if (obj) {
			state.cards = [
				...state.cards.map(card => card.cardNumber !== obj.cardNumber ? card : {...card,...obj})
			]
		}
	},
	REMOVE_CARD: (state, id) => {
		state.cards = state.cards.filter(card => card.cardID !== id)
	},
	UPDATE_BROWSER: (state, obj) => {
		state.browser = obj
	},
	UPDATE_FILTERED_RESULTS_COUNT: (state, obj) => {
		state.activeFilters[obj.entity].resultsCount = obj.count
	},
	UPDATE_FILTERED_RESULTS: (state, obj) => {
		state.activeFilters[obj.entity].results = obj.results
	},
	UPDATE_SELECTED_RANGE: (state, obj) => {
		state.activeFilters[obj.entity].selectedRange = obj.newRange
	},
	UPDATE_SELECTED_CATEGORIES: (state, obj) => {
		state.activeFilters[obj.entity].selectedCategories = obj.categories
	},
	UPDATE_SELECTED_CRITERIAS: (state, obj) => {
		state.activeFilters[obj.entity].selectedCriterias = obj.criterias
	},
	UPDATE_TOP_PERFORMANCE_SELECTION: (state, obj) => {
		state.activeFilters[obj.entity].onlyTopPerformance = obj.newState
	},
	RESET_FILTER: (state, obj) => {
		state.activeFilters[obj.entity] = {
			resultsCount: 0,
			selectedRange: 150,
			selectedCategories: [],
			selectedCriterias: [],
			onlyTopPerformance: false
		}
	},
	UPDATE_ENTITY: (state, newEntity) => {
		state.lastEntity = newEntity
	},
	UPDATE_SALES_ENTITY: (state, newEntity) => {
		state.lastSalesEntity = newEntity
	},
	UPDATE_SEASON_ENTITY: (state, newEntity) => {
		state.lastSeasonEntity = newEntity
	}
}